import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  firebaseConnect,
  // getFirebase,
  // isLoaded,
  // isEmpty
} from 'react-redux-firebase';

import {
  path as Rpath,
  pathOr as RpathOr,
  ascend as Rascend,
  prop as Rprop,
  sort as Rsort,
  values as RValues,
  propOr as RpropOr,
  map as Rmap,
  compose as Rcompose,
  pickBy as RpickBy,
  toPairs as RtoPairs,
} from 'ramda';

import { FlexCarouselFactory } from '../../components/sliders/FlexCarousel';
// import { Carousel as Carousel3dHorizontal } from '../../components/sliders/Carousel3D';
import Carousel3dHorizontal from '../../lab/components/Carousel3D';
// Carousel3dHorizontal

// import {
//   // SlickSlider,
//   GenericCarousel,
// } from '../sliders';

// import ProjectorControl from './ProjectorControl'

import { BrandInfo } from '../brand';
import {
  EmptyBox,
  Template1,
} from '../templates';

import { command as commandActions } from '../../redux/actions';

import { withAppContext } from '../../lib/context';
import { contextA } from '../../redux/store/configureStore';
// import { settings } from 'cluster';


const sortObject = (objectToSort, orderFunc, mul = 1) => {
  const objectArray = Rsort(orderFunc, RValues(objectToSort));
  const sortedObject = objectArray
    .reduce((acc, val, currentIndex) => Object.assign(
      acc,
      { [val.key]: Object.assign({}, val, { sequence: currentIndex * mul }) },
    ), {});
  return sortedObject;
};

const bySequence = Rascend(Rprop('sequence'));

const Projector = (props) => {
  console.log('::::: props', props)
  // master data
  const {
    playlists = {},
    contents = {},
    templates = {},
    spots = {},
    partners,
  } = props;
  const { auth } = props;
  const { location } = props;
  const { search:params = '' } = location;
  const { origin } = window.location;

  const searchParams = new URLSearchParams(params);
  // console.log(':::: screen ', searchParams.get('screen'));
  // console.log(':::: box a ', searchParams.get('a'));
  // console.log(':::: box b ', searchParams.get('b'));
  // console.log(':::: box c ', searchParams.get('c'));
  // console.log(':::: box d ', searchParams.get('d'));


  const queryMatrix = params.replace('?', '').split(';');
  console.log(':::: queryMatrix', queryMatrix)
  let matrix = [];
  queryMatrix.forEach((item) => {
    matrix.push(item.split(','));
  });
  console.log(':::: matrix', matrix);

  // TODO: grab from settings
  const remoteUrl = `${origin}/remote/${auth.uid}`;

  // partner && partnerSettings
  const partner = (partners && Object.keys(partners) && partners[Object.keys(partners)[0]]) || {};
  const { settings: partnerSettings = {} } = partner;
  // console.log('Projector mapStateToProps ownProps 2', props.templateKey, props )

  // console.log('Projector mapStateToProps ownProps 2', props.spotName, props.spots)
  const defaultTemplateId = props.templateKey || RpathOr('NO TEMPLATE', ['defaultTemplateId'], partnerSettings);

  const partnerUrl = RpathOr('https://www.showdigi.com', ['defaultUrl'], partnerSettings);

  // template && templateSettings
  const templateByName = Rcompose(
    RpathOr(null, [0, 1]),
    RtoPairs,
    RpickBy(v => v.name === props.templateName),
  )(templates);
  const templateBySpot = Rcompose(
    RpathOr(null, [0, 1, 'settings', 'defaultTemplate']),
    RtoPairs,
    RpickBy(v => v.name === props.spotName),
  )(spots);
  const templateByKey = RpathOr({}, [defaultTemplateId], templates);
  const template = templateByName || templateBySpot || templateByKey;

  const { settings: templateSettings = {} } = template;
  const { url: templateUrl } = templateSettings;

  const playersMap = {
    horizontal: FlexCarouselFactory('row'),
    vertical: FlexCarouselFactory('column'),
    brand: BrandInfo,
    empty: EmptyBox,
    horizontal3D: Carousel3dHorizontal,
  };


  // Box Settings
  const getBoxSettings = (key, settings) => RpathOr({}, [`box${key}`], settings);

  const getBoxData = (key, tmplSettings) => {
    const settings = getBoxSettings(key, tmplSettings);
    const { playlistId } = settings;
    const playlist = (playlistId && playlists[playlistId]) || {};

    const { items: playlistItems = {} } = playlist;
    // TODO: Use Inner Join TO Remove Deleted ???
    const items = Rmap(v => RpropOr(v, v.key, contents), playlistItems);
    const slides = Object.keys(items || {})
      .reduce((acc, curr, index) => Object.assign(acc, { [`slide${index + 1}`]: items[curr].photoURL }), {});

    const sortedItems = sortObject(items, bySequence);

    const slidesData = Object.keys(sortedItems || {})
      .map(itemKey => ({
        key: itemKey,
        ...items[itemKey],
      }));
    const player = RpropOr(EmptyBox, settings.playerType || 'empty', playersMap);

    return Object.assign({}, settings, {
      items: slidesData, slides, slidesData, component: player,
    });
  };

  // playlist && items (moved)

  // template Styles
  const { backgroundColor = {} } = templateSettings;
  const templateStyle = {
    background: `rgba(${backgroundColor.r}, ${backgroundColor.g}, ${backgroundColor.b}, ${backgroundColor.a})`,
  };

  const getBoxStyle = (boxStl) => {
    const { bgColor = {} } = boxStl;
    const boxStyle = {};
    if (bgColor) {
      boxStyle.background =
        `rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, ${bgColor.a})`;
    }
    return boxStyle;
  };

  const templateProps = ['A', 'B', 'C', 'D'].reduce((acc, box) => {
    const data = getBoxData(box, templateSettings);
    const BoxPlayer = data.component;
    const boxStyle = getBoxStyle(data);
    const {
      overlayColor, textColor, showTitle, showDescription,
    } = data;
    // console.log('getBoxData data', box, data, templateSettings);
    return Object.assign(acc, {
      [`box${box}`]: (
        <BoxPlayer
          {...props}
          autoplay
          {...data}
          position={box}
          // items={slidesData}
          templateStyle={templateStyle}
          boxStyle={boxStyle}
          brandUrl={templateUrl || partnerUrl || remoteUrl}
          logo={partner.photoURL}
          overlayColor={overlayColor}
          textColor={textColor}
          showTitle={showTitle}
          showDescription={showDescription}
        />),
    });
  }, {});


  return (
    <div style={templateStyle}>
      <Template1 layout={params} {...templateProps} />
    </div>
  );
};
Projector.propTypes = {
  playlists: PropTypes.object,
  contents: PropTypes.object,
  templates: PropTypes.object,
  partners: PropTypes.object,
  auth: PropTypes.object,
  templateKey: PropTypes.string,
  templateName: PropTypes.string,
};
Projector.defaultProps = {
  playlists: {},
  contents: {},
  templates: {},
  partners: {},
  auth: {},
  templateKey: '',
  templateName: '',
};

// Redux && export staf
const playListsPath = key => `private/${key}/playlists`;
const templatesPath = key => `private/${key}/templates`;
const spotsPath = key => `private/${key}/spots`;
const contentsPath = key => `private/${key}/contents`;
const getData = (path, data) => {
  const dataPath = path.split('/').filter(item => item);
  // .concat(resource)
  return Rpath(dataPath, data);
};

const mapStateToProps = (state, props) => {
  const key = (props && props.partner && props.partner.key) || 'NO_KEY';

  const templateKey = RpathOr(null, ['location', 'state', 'templateKey'], state.router);
  const templateKeyParam = RpathOr(null, ['match', 'params', 'templateKey'], props);

  const templateName = RpathOr(null, ['match', 'params', 'templateName'], props);
  const spotName = RpathOr(null, ['match', 'params', 'spotName'], props);

  // console.log('mapStateToProps', templateKey, templateKeyParam);
  return ({
    context: state.context,
    command: state.command,
    auth: state.firebase.auth,
    playlists: getData(playListsPath(key), state.firebase.data),
    templates: getData(templatesPath(key), state.firebase.data),
    spots: getData(spotsPath(key), state.firebase.data),
    contents: getData(contentsPath(key), state.firebase.data),
    templateKey: templateKey || templateKeyParam,
    templateName,
    spotName,
  });
};

const mapDispatchToProps = dispatch => bindActionCreators(commandActions, dispatch);

// const firebaseConfigProjector = (props, firebase) => {
const firebaseConfigProjector = (props) => {
  const key = (props && props.partner && props.partner.key) || 'NO_KEY';
  // console.log('firebaseConfigProjector:', key, props);
  return (
    [
      { path: `private/${key}/playlists/` },
      { path: `private/${key}/templates/` },
      { path: `private/${key}/spots/` },
      { path: `private/${key}/contents/` },
    ]
  );
};

const ComposedComponent = compose(
  firebaseConnect(firebaseConfigProjector),
  connect(mapStateToProps, mapDispatchToProps, null, {
    context: contextA,
  }),

)(Projector);


const ComposedComponent2 = withRouter(ComposedComponent);

const RoutedComponent = withAppContext(ComposedComponent2);


export default RoutedComponent;



// WEBPACK FOOTER //
// ./src/components/projector/Projector.js